<ng-container *ngIf="lenderDocs$ | async as lenderDocs; else noDocs">
	<ui-section
		title="Lender Documents"
		[isEmpty]="lenderDocs.length === 0"
		emptyMessage="No lender documents"
		data-intercom-target="sync-lender-documents-section"
	>
		<div section-content class="space-y-2">
			<ui-card
				*ngFor="let doc of lenderDocs"
				(click)="openPDF(doc)"
				class="hover:bg-gray-50 duration-300 cursor-pointer"
			>
				<div card-content>
					<div class="flex gap-4">
						<div
							class="w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center"
						>
							<i-tabler name="file-text" class="text-blue-600 w-4 h-4" />
						</div>
						<div class="space-y-1">
							<h6 class="h6 mb-0">{{ doc.name }}</h6>
							<p class="p-xs">Uploaded, {{ doc.uploadedAt | closerDate }}</p>
						</div>
					</div>
				</div>
			</ui-card>
		</div>
	</ui-section>
</ng-container>
<ng-template #noDocs>
	<ui-section title="No Lender Documents" emptyMessage="No lender documents">
	</ui-section>
</ng-template>
